import React from "react";
import { Row } from "antd";
// import PropTypes from "prop-types";
import classes from "../Pages.module.css";
import DataField from "./DataField";

const BasicDetail = (props) => {
console.log(props, "ad", props.data.type=='cr')
  // const planDateRef = useRef(null);
  // const requirementDateRef = useRef(null);
  // const departmentRef = useRef(null);
  // const [account, setAccount] = useState([]);
  // const requestedByRef = useRef(null);

  // const handleChange = (e, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["purreqHdr"]];
  //     newdata[0][param] = e.target.value;
  //     return {
  //       ...data,
  //       purreqHdr: newdata,
  //     };
  //   });
  // };

  const handleSChange = (val, param) => {
    props.setData((data) => {
      const newdata = [...data["purreqHdr"]];
      newdata[0][param] = val;
 //  we need to api call for get new list here


      return {
        ...data,
        purreqHdr: newdata,
      };
    });
  };
  

  const handleDChange = (date, dateString, param) => {
    props.setData((data) => {
      const newdata = [...data["purreqHdr"]];
      newdata[0][param] = dateString;
      return {
        ...data,
        purreqHdr: newdata,
      };
    });
  };

  return (
    <div>
      <p></p>
      <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
        {!props.create && (
          <DataField
            editMode={props.editMode}
            lg={12}
            md={24}
            name="Requisition Code"
            param="REQ_CODE"
            value={props.data.req_code}
          />
        )}

        {/* <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="plan_date"
          required="True"
          name="Plan Date"
          param="plan_date"
          value={props.data.plan_date}
          rules={[{ message: "missing name" }]}
          ref={planDateRef}
          onNextFocus={() => requirementDateRef.current.focus()}
        /> */}

        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="report_date"
          required="True"
          name="Report Date"
          param="report_date"
          value={props.data.report_date}
          rules={[{ message: "missing name" }]}
          // ref={requirementDateRef}
          // onNextFocus={() => departmentRef.current.focus()}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.TYPE}
          type="Select"
          name="Type"
          // required="True"
          id="employee"
          param="type"
          value={props.data.type}
          // ref={requestedByRef}
          onNextFocus={null}
        />

        
        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          // options={props.data.type=='cr' ? props.ad.accountcr: props.ad.accountdr }
          options={ props.data.type==='cr' ? props.ad.accountcr: props.ad.accountdr } 
          type="Select"
          name="Account"
          id="account_code"
          // required="True"
          param="account_code"
          value={props.data.account_code}
          // ref={departmentRef}
          // onNextFocus={() => requestedByRef.current.focus()}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.dealer_name}
          type="Select"
          name="Dealer Name"
          // required="True"
          id="dealer_code"
          param="dealer_code"
          value={props.data.dealer_code}
          // ref={requestedByRef}
          onNextFocus={null}
        />

         <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.groups}
          type="Select"
          name="Group"
          // required="True"
          id="group_code"
          param="group_code"
          value={props.data.group_code}
          // ref={requestedByRef}
          onNextFocus={null}
        />

         
      </Row>
    </div>
  );
};

export default BasicDetail;
